import { css } from '@emotion/react';
import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { theme } from 'styles/theme';

type ButtonLinkProperties = {
	children: ReactNode;
	to: string;
	outline?: boolean;
	ghost?: boolean;
	block?: boolean;
	xSmall?: boolean;
	small?: boolean;
	large?: boolean;
	square?: boolean;
	external?: boolean;
	disabled?: boolean;
};

export const ButtonLink = ({
	children,
	to,
	outline,
	ghost,
	block,
	xSmall,
	small,
	large,
	square,
	external,
	disabled,
}: ButtonLinkProperties) => {
	return !external ? (
		<NavLink
			css={NavLinkStyle({
				outline: outline,
				ghost: ghost,
				block: block,
				xSmall: xSmall,
				small: small,
				large: large,
				square: square,
				disabled: disabled,
			})}
			to={to}
		>
			{children}
		</NavLink>
	) : (
		<a
			href={to}
			css={NavLinkStyle({
				outline: outline,
				ghost: ghost,
				block: block,
				xSmall: xSmall,
				small: small,
				large: large,
				square: square,
				disabled: disabled,
			})}
			onClick={(e) => {
				e.stopPropagation();

				if (disabled) {
					e.preventDefault();
				}
			}}
			target={external ? '_blank' : ''}
			rel="noopener noreferrer"
		>
			{children}
		</a>
	);
};

const NavLinkStyle = ({
	outline,
	ghost,
	block,
	xSmall,
	small,
	large,
	square,
	disabled,
}: {
	outline?: boolean;
	ghost?: boolean;
	block?: boolean;
	xSmall?: boolean;
	small?: boolean;
	large?: boolean;
	square?: boolean;
	disabled?: boolean;
}) => css`
	display: inline-flex;
	align-items: center;
	background: ${theme.color.primary['400']};
	box-shadow: 0 2px 4px 0 rgba(103, 120, 255, 0.25);
	border-radius: 8px;
	font-size: 14px;
	line-height: 20px;
	color: #fff;
	border: 0;
	height: 44px;
	padding: 0 24px;
	font-weight: 600;

	&:hover {
		color: #fff;
		text-decoration: none;
	}

	&:active {
		outline: none;
		opacity: 0.5;
	}

	&:focus {
		outline: none;
	}

	${xSmall &&
	css`
		height: 32px;
		font-size: 13px;
		line-height: 20px;
		padding: 0 12px;
	`}

	${small &&
	css`
		height: 36px;
		font-size: 13px;
		line-height: 20px;
		padding: 0 16px;

		${square &&
		css`
			padding: 0;
			display: inline-flex;
			justify-content: center;
			align-items: center;
			width: 36px;
		`};
	`}

	${large &&
	css`
		height: 48px;
	`}

				${block &&
	css`
		width: 100%;
	`}

				${outline &&
	css`
		background: #ffffff;
		border: 1px solid #e2e3e9;
		border-radius: 8px;
		color: ${theme.color.text['300']};
		box-shadow: none;

		&:hover {
			color: ${theme.color.text['400']};
		}
	`}

				${ghost &&
	css`
		background: transparent;
		border: 1px solid transparent;
		border-radius: 8px;
		color: ${theme.color.text['300']};
		box-shadow: none;

		&:hover {
			color: ${theme.color.text['400']};
		}
	`}

	${disabled &&
	css`
		opacity: 0.3;

		&:hover {
			cursor: default;
		}
	`}
`;
